import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Text,
} from "@chakra-ui/react";

import { CloseIcon } from "@/components/icons";
import { emojis } from "@/utils/avatars";

const SelectAvatar = ({
  isOpen,
  onClose,
  handleOnAvatarChange,
}: {
  isOpen: boolean;
  onClose: () => void;
  handleOnAvatarChange: (avatarIndex: number) => void;
}) => {
  return (
    <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent
        sx={{
          padding: "30px 20px",
          background: "#fff",
          borderRadius: "16px 16px 0 0",
        }}
      >
        <DrawerBody
          sx={{
            padding: "0",
          }}
        >
          <Box
            sx={{
              position: "relative",
            }}
          >
            <CloseIcon
              onClick={onClose}
              style={{
                position: "absolute",
                top: "50%",
                right: "0px",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                color: "#333",
                transform: "translateY(-50%)",
              }}
            ></CloseIcon>
            <Flex align={"center"} justify={"center"}>
              <Text
                sx={{
                  color: "#D8762B",
                  fontSize: "24px",
                  fontWeight: 700,
                }}
              >
                Select Emoji
              </Text>
            </Flex>
          </Box>

          <Flex
            sx={{
              flexWrap: "wrap",
              justifyContent: "space-between",
              padding: "0 10px",
              marginTop: "20px",
              height: "50vh",
              overflowY: "auto",
            }}
          >
            {emojis.map((emoji, index) => (
              <Flex
                key={emoji}
                onClick={() => {
                  handleOnAvatarChange(index);
                }}
                sx={{
                  width: "36px",
                  height: "28px",
                  marginBottom: "10px",
                  fontSize: "32px",
                }}
                align={"center"}
                justify={"center"}
              >
                {emoji}
              </Flex>
            ))}
            {[...Array(100)].map((_, i) => (
              <Box
                key={`empty-${i}`}
                sx={{
                  width: "36px",
                  height: "0",
                  marginBottom: "0",
                  visibility: "hidden",
                }}
              />
            ))}
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default SelectAvatar;
